// extracted by mini-css-extract-plugin
module.exports = {"cookies":"CookieWarning-module--cookies--2BTTW","cookiesChoices":"CookieWarning-module--cookiesChoices--2L1U8","acceptCookies":"CookieWarning-module--acceptCookies--28tBi"};